import { Grid } from '@mui/joy'
import { TMS_DOMAIN } from '~/shared/config/env'
import { LinkDecorator } from '~/shared/ui/Buttons'
import { DatePickerInput, TextareaInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type MainProps = {
  loading: boolean
  driverExtId?: UniqueId
  carExtId?: UniqueId
}

export function Main({ loading, driverExtId, carExtId }: MainProps) {
  return (
    <Container>
      <ContainerTitle>Основная информация</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={3}>
          <DatePickerInput
            label='Дата протокола'
            name='protocolDate'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={3}>
          <DatePickerInput
            label='Дата загрузки'
            name='createdAt'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='VIN'
            name='carVin'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='Номер протокола'
            name='protocolNumber'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={3}>
          <TextInput
            label='Гос. номер'
            name='carPlateNumber'
            readOnly
            skeletonShow={loading}
            endDecorator={
              carExtId && (
                <LinkDecorator
                  tooltipText='Перейти в карточку водителя'
                  href={`${TMS_DOMAIN}cars/${carExtId}/details`}
                />
              )
            }
          />
        </Grid>
        <Grid xs={3}>
          <TextInput
            label='Автомобиль'
            name='carBrandModel'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='Организация'
            name='paymentOrgName'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='СТС'
            name='carSts'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
        <Grid xs={6}>
          <TextareaInput
            label='Комментарий'
            name='comment'
            minRows={4}
            maxRows={4}
            readOnly
            skeletonShow={loading}
            sx={{
              height: '138px',
            }}
          />
        </Grid>
        <Grid container xs={6} spacing={2.5}>
          <Grid xs={12}>
            <TextInput
              label='Подразделение'
              name='tmsSubdivisionName'
              readOnly
              skeletonShow={loading}
            />
          </Grid>
          <Grid xs={12}>
            <TextInput
              label='Водитель'
              name='tmsDriverName'
              readOnly
              skeletonShow={loading}
              endDecorator={
                driverExtId && (
                  <LinkDecorator
                    tooltipText='Перейти в карточку водителя'
                    href={`${TMS_DOMAIN}drivers/${driverExtId}/details`}
                  />
                )
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
